import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getMonthlyReportAction } from '../../redux/actions/admin/AdminAction';
import PropTypes from 'prop-types';
import SimpleDataTables from '../Common/SimpleDataTables';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const GetMonthlyReport = ({ products, getMonthlyReportAction }) => {
    const [dateRange, setDateRange] = useState({
        startDate: null,
        endDate: null
    });
    const [rows, setRows] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState('waiting');

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoadingStatus('fetching');
        const { startDate, endDate } = dateRange;
        if(!startDate || !endDate) {
            toast.error('Enter a valid Start Date and End Date');
            setLoadingStatus('waiting');
            return false;
        }
        getMonthlyReportAction(startDate, endDate)
            .catch((error) => console.log(error));
    };
    
    useEffect(() => {
        if(products && products.length > 0) {
            setRows(products);
            setLoadingStatus('done');
        }
    }, [products]);

    const handleDateChange = (e) => {
        setDateRange((prevDate) => {
            return {
                ...prevDate,
                [e.target.name]: e.target.value
            };
        });
    };

    const columns = [
        {
            label: 'Product Id',
            field: 'productId',
            sort: 'asc',
            width: 150
        },
        {
            label: 'Name',
            field: 'productName',
            sort: 'asc',
            width: 150
        },
        {
            label: 'Description',
            field: 'productDescription',
            sort: 'asc',
            width: 270
        },
        {
            label: 'Category',
            field: 'productType',
            sort: 'asc',
            width: 200
        },
        {
            label: 'Quantity',
            field: 'productQuantity',
            sort: 'asc',
            width: 100
        },
        {
            label: 'Date added',
            field: 'date',
            sort: 'asc',
            width: 150
        }
    ];

    return (
        <div className='container'>
            <div className='row mt-2 w-100'>
                <div className='col-md-6 display-4'>Get Monthly Report</div>
                <form className='col-md-4' onSubmit={handleSubmit}>
                    <div className="form-group row">
                        <label htmlFor="startDate" className="col-md-4 col-form-label">Start Date</label>
                        <div className="col-md-8">
                            <input type="date" onChange={handleDateChange} className="form-control" id="startDate" name="startDate" placeholder="Start date" />
                        </div>
                    </div> <br />
                    <div className="form-group row">
                        <label htmlFor="endDate" className="col-md-4 col-form-label">End Date</label>
                        <div className="col-md-8">
                            <input type="date" onChange={handleDateChange} className="form-control" id="endDate" name='endDate' placeholder="End date" />
                        </div>
                    </div>
                    <div className="form-group row w-100">
                        <div className="col-md-6 mt-1">
                            <button type="submit" className="btn btn-sm btn-primary">Fetch Report</button>
                        </div>
                        <div className="col-md-6 mt-1">
                            <Link to='/admin' className='btn btn-sm btn-secondary'><FontAwesomeIcon className='FntIcon' key={1} icon={faArrowLeft} />&nbsp; &nbsp; Go Back</Link>
                        </div>
                    </div>
                </form>
            </div>
            {rows && rows.length === 0 ? 
                (
                    <>
                        <div className="d-flex justify-content-center">
                            <div className="spinner-grow text-primary" role="status">
                            </div>
                        </div>
                        <p className='text-center'>
                            {loadingStatus === 'waiting' ? 'Waiting for your response...' : (
                                loadingStatus === 'fetching' ? 'Loading data...' : ''
                            )}
                        </p>
                    </>
                ) : 
                // <DataTable columns={columns} rows={rows} />
                <SimpleDataTables columns={columns} rows={rows} />
            }
            <ToastContainer />
        </div>
    );
};

GetMonthlyReport.propTypes = {
    products: PropTypes.array.isRequired,
    getMonthlyReportAction: PropTypes.func.isRequired
};

GetMonthlyReport.defaultProps = {
    products: []
};

const mapStateToProps = (state) => {
    return {
        products: state.admins
    };
};

const mapDispatchToProps = {
    getMonthlyReportAction
};

export default connect(mapStateToProps, mapDispatchToProps)(GetMonthlyReport);